module.exports = __webpack_public_path__ + "media/images/proof_links/colored/playgoogle-2dbe61cb6167c5072b694d9fa1dadfbe.svg";